import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const PickPlanSectionV2Wrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1120px;
  margin: auto;
  position: relative;
  z-index: 1;

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    margin-bottom: 0px;
    padding: 0px 24px;
  }
`;
export const PickPlanEggBg = styled.img`
  position: absolute;
  z-index: 0;
  top: -100px;

  @media (max-width: ${TabletWidth}px) {
    top: -60px;
  }
`;

export const PickPlanSectionV2Title = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
  max-width: 490px;
  margin-bottom: 50px;
  z-index: 1;
  color: ${getColor('GRAY_70')};
  position: relative;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 32px;
    max-width: 330px;
  }
`;

export const PickPlanSectionV2TitleVisible = styled.span`
  position: absolute;
  top: 0;
  left: 0;
`;

export const PickPlanSectionV2TitleNotVisible = styled.span`
  visibility: hidden;
`;

export const PickPlanSectionV2Content = styled.div`
  z-index: 1;
`;

export const PickPlanSectionV2Products = styled.div`
  display: flex;
  gap: 35px;
  justify-content: center;
  margin-bottom: 32px;
  max-width: 1100px;
  flex-wrap: wrap;

  @media (max-width: ${TabletWidth}px) {
    max-width: 400px;
    margin-bottom: 24px;
  }
`;

export const PickPlanSectionV2Awards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 28px;
  width: 100%;
  max-width: 330px;
  width: 100%;
  margin: auto;
`;

export const PickPlanSectionV2AwardImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;
